module.exports = __webpack_public_path__ + "static/media/superstars.1971a06e.png";